import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";

const BOOTCAMP_URL = "/bootcamp";
const STORAGE_KEY = "shinrai-promo-bar-dismissed-v2";
const BAR_HEIGHT_PX = 56;

export default function PromoStickyBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY) === "1";
    setVisible(!dismissed);
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--promo-bar-h",
      visible ? `${BAR_HEIGHT_PX}px` : "0px"
    );
    return () => {
      document.documentElement.style.setProperty("--promo-bar-h", "0px");
    };
  }, [visible]);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] text-white"
      style={{
        height: `${BAR_HEIGHT_PX}px`,
        backgroundColor: "#000",
        backgroundImage:
          "linear-gradient(90deg, rgba(255,59,48,0.08) 0%, rgba(0,0,0,0) 30%, rgba(0,0,0,0) 70%, rgba(0,191,255,0.10) 100%)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
      }}
      data-testid="promo-sticky-bar"
    >
      <div className="max-w-7xl mx-auto h-full px-4 sm:px-10 flex items-center justify-between gap-4">
        <div className="flex-1 flex items-center justify-center sm:justify-start gap-3 min-w-0">
          <span
            className="hidden sm:inline-flex items-center justify-center px-2.5 py-1 text-[10px] font-bold tracking-[0.2em] uppercase flex-shrink-0"
            style={{
              backgroundColor: "#FF3B30",
              color: "#fff",
              boxShadow: "0 0 18px rgba(255,59,48,0.45)",
            }}
          >
            ● Urgent
          </span>
          <span aria-hidden="true" className="sm:hidden text-lg leading-none">
            🚨
          </span>

          <span className="hidden sm:inline text-sm font-medium text-white/90 truncate">
            <span className="font-bold text-white">SESSION EXCLUSIVE</span>
            <span className="mx-2 text-white/40">·</span>
            Il reste{" "}
            <span className="text-[#FF3B30] font-bold">10 places</span>{" "}
            pour le Bootcamp B2B
            <span className="mx-2 text-white/40">·</span>
            Candidatures closes{" "}
            <span className="text-[#FF3B30] font-bold">vendredi</span>
          </span>
          <span className="sm:hidden text-xs font-medium text-white/90 truncate">
            <span className="text-[#FF3B30] font-bold">10 places</span>{" "}
            Bootcamp B2B · jusqu&apos;à vendredi
          </span>

          <Link
            to={BOOTCAMP_URL}
            className="group flex-shrink-0 inline-flex items-center gap-2 px-3 sm:px-4 py-2 font-mono font-bold text-[11px] sm:text-xs uppercase tracking-[0.14em] transition-all"
            style={{
              backgroundColor: "#00BFFF",
              color: "#000",
              boxShadow: "0 0 20px rgba(0,191,255,0.4)",
            }}
            data-testid="promo-sticky-bar-link"
          >
            <span className="hidden xs:inline sm:inline">
              {"C'est quoi exactement ?"}
            </span>
            <span className="xs:hidden sm:hidden">{"C'est quoi ?"}</span>
            <ArrowRight
              size={14}
              strokeWidth={2.5}
              className="transition-transform group-hover:translate-x-0.5"
            />
          </Link>
        </div>

        <button
          onClick={dismiss}
          className="flex-shrink-0 flex items-center justify-center w-8 h-8 text-white/55 hover:text-white transition-colors"
          aria-label="Fermer la barre promotionnelle"
          data-testid="promo-sticky-bar-close"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
